export const GET_B2B_USERS_REPORT = "get_b2b_users_report";
export const SELECT_B2B_USER = "select_b2b_user";
export const ADD_TRANSFER = "add_transfer";
export const GET_B2B_USERS_TOTAL_DEBT = "get_b2b_users_total_debt"